import { isDefined } from "@clipboard-health/util-ts";
import { TextField } from "@mui/material";
import { type FieldErrors, type UseFormRegister } from "react-hook-form";

import { type CredentialsFormData } from "../api/schema";

interface UKGTimeclockCredentialsProps {
  register: UseFormRegister<CredentialsFormData>;
  errors: FieldErrors<CredentialsFormData>;
  externalIdErrorPlaceholder?: string;
}

export function UKGTimeclockCredentials({
  register,
  errors,
  externalIdErrorPlaceholder,
}: UKGTimeclockCredentialsProps) {
  return (
    <>
      <TextField
        fullWidth
        label="UKG Person Number"
        InputLabelProps={{
          shrink: isDefined(externalIdErrorPlaceholder) ? true : undefined,
        }}
        error={!!errors.externalId}
        sx={
          isDefined(externalIdErrorPlaceholder)
            ? {
                "& .MuiInputBase-input.Mui-disabled": {
                  WebkitTextFillColor: "#000000",
                },
              }
            : {}
        }
        helperText={errors.externalId?.message}
        disabled={isDefined(externalIdErrorPlaceholder)}
        placeholder={externalIdErrorPlaceholder}
        {...register("externalId")}
      />
      <TextField
        fullWidth
        label="Time Clock Badge"
        error={!!errors.timeclockBadge}
        helperText={errors.timeclockBadge?.message}
        {...register("timeclockBadge")}
      />
    </>
  );
}
